import { appEntries } from "@/mocks/appEntries";
import { siteMeta } from "@/mocks/siteMeta";
import SectionHeading from "./SectionHeading";

export default function AppSection() {
  return (
    <section id="app" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="APP入口与下载方式"
          title="按设备选择合适的入口，安装或直接使用"
          desc="不同终端的获取方式并不相同。下面是安卓、苹果、电脑与网页版各自的入口说明与操作步骤，照着做即可完成。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-5 md:gap-6">
          <div className="lg:col-span-2 rounded-lg overflow-hidden border border-background-200 bg-background-50 flex flex-col">
            <div className="relative w-full h-56 md:h-72">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20dark%20smartphone%20app%20interface%20mockup%20floating%20over%20a%20warm%20vermillion%20and%20golden%20amber%20gradient%20background%2C%20abstract%20minimal%20ui%20blocks%20and%20rounded%20cards%2C%20soft%20glow%20and%20depth%20of%20field%2C%20editorial%20tech%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=900&height=1000&seq=app-preview-97v-2026&orientation=portrait"
                alt="97视频APP入口界面示意图"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
              <div className="absolute left-4 right-4 bottom-4">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                  <i className="ri-smartphone-line"></i>APP入口
                </span>
                <p className="mt-2 text-background-50 text-sm leading-relaxed">
                  通过最新可用地址页面内的官方入口获取安装包，安装后启动更快、打开更稳定。
                </p>
              </div>
            </div>
            <div className="p-4 md:p-5 grid grid-cols-3 gap-3">
              <div className="text-center">
                <div className="font-heading text-lg font-bold text-foreground-950">v3.2.1</div>
                <div className="text-xs text-foreground-500 mt-1">最新版本</div>
              </div>
              <div className="text-center border-x border-background-200">
                <div className="font-heading text-lg font-bold text-foreground-950">28 MB</div>
                <div className="text-xs text-foreground-500 mt-1">安装包体积</div>
              </div>
              <div className="text-center">
                <div className="font-heading text-lg font-bold text-foreground-950">4 端</div>
                <div className="text-xs text-foreground-500 mt-1">支持终端</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {appEntries.map((app) => (
              <article
                key={app.id}
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
              >
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center text-xl">
                    <i className={app.icon}></i>
                  </span>
                  <div>
                    <h3 className="font-heading font-semibold text-base text-foreground-950">{app.platform}</h3>
                    <p className="text-xs text-foreground-500 mt-0.5">
                      {app.version} · {app.size}
                    </p>
                  </div>
                </div>

                <p className="mt-3 inline-flex items-center gap-1.5 text-xs text-secondary-700 bg-secondary-50 border border-secondary-100 px-2.5 py-1 rounded-md w-fit">
                  <i className="ri-cpu-line"></i>
                  {app.requirement}
                </p>

                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{app.note}</p>

                <ol className="mt-4 flex flex-col gap-2">
                  {app.steps.map((step, i) => (
                    <li key={step} className="flex items-start gap-2 text-sm text-foreground-700">
                      <span className="mt-0.5 w-5 h-5 shrink-0 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold flex items-center justify-center">
                        {i + 1}
                      </span>
                      <span className="leading-relaxed">{step}</span>
                    </li>
                  ))}
                </ol>
              </article>
            ))}
          </div>
        </div>

        <p className="mt-6 text-xs md:text-sm text-foreground-500 text-center">
          安装提示：安装包请务必通过最新可用地址（{siteMeta.updatedDate} 更新）页面内的入口获取，避免使用来源不明的文件。
        </p>
      </div>
    </section>
  );
}